export const GET_FACILITIES = 'GET_FACILITIES';
export const SET_FACILITIES = 'SET_FACILITIES';
export const GET_FACILITY = 'GET_FACILITY';
export const SET_FACILITY = 'SET_FACILITY';